<template>
  <div class="direct-customer-review-page">
    <!-- 客保到期提醒 -->
    <div
      v-if="false"
      class="expire-notice"
    >
      <div class="expire-notice__icon">
        <i class="el-icon-warning-outline" />
      </div>
      <div class="expire-notice__viewport">
        <div
          :class="['expire-notice__track', { 'is-animating': expireNotice.animating }]"
          :style="expireNoticeTrackStyle"
          @transitionend="handleExpireNoticeTransitionEnd"
        >
          <div class="expire-notice__item">
            {{ currentExpireNotice.text }}
          </div>
          <div
            v-if="hasMultipleExpireNotice"
            class="expire-notice__item"
          >
            {{ nextExpireNotice.text }}
          </div>
        </div>
      </div>
    </div>

    <!-- 页面标题与操作 -->
    <div class="page-heading">
      <div class="page-heading__actions">
        <el-button
          type="primary"
          plain
          size="small"
          @click="handleOpenLogDrawer"
        >
          操作日志
        </el-button>
      </div>
    </div>

    <!-- 审核状态 Tab -->
    <div
      class="status-tabs"
      role="tablist"
    >
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        role="tab"
        :class="['status-tab', { 'is-active': activeTab === tab.key }]"
        @click="handleTabChange(tab.key)"
      >
        {{ tab.label }}
        <span class="status-tab__count">{{ tabCountsText[tab.key] }}</span>
      </button>
    </div>

    <!-- 查询条件：参照 AggregationReport/Index.vue 的 Row/Col 响应式搜索栏 -->
    <div class="query-conditions">
      <el-form
        :inline="true"
        class="query-form"
        @submit.native.prevent
      >
        <el-row
          :gutter="20"
          class="query-row"
        >
          <el-col
            v-show="queryFieldVisibility.budget_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.identify_code"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.identify_code"
                clearable
                placeholder="请输入识别名称"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.owner_name"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-input
                v-model.trim="query.form.owner_name"
                clearable
                placeholder="请输入所属"
                @keyup.enter.native="handleFilter"
              />
            </el-form-item>
          </el-col>

          <el-col
            v-show="queryFieldVisibility.is_claim"
            :span="queryColSpan"
            class="query-item"
          >
            <el-form-item>
              <el-select
                v-model="query.form.is_claim"
                clearable
                placeholder="请选择进入方式"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in sourceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            :span="queryActionSpan"
            class="query-item query-item--actions"
          >
            <div class="query-buttons">
              <el-button
                plain
                type="primary"
                :loading="table.loading"
                @click="handleReset"
              >
                重置
              </el-button>
              <el-button
                type="primary"
                :loading="table.loading"
                @click="handleFilter"
              >
                查询
              </el-button>
              <el-button
                v-if="showQueryToggle"
                type="text"
                class="query-toggle"
                @click="toggleQueryExpand"
              >
                {{ queryExpanded ? '收起' : '展开' }}
                <i :class="queryExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 记录列表 -->
    <div
      v-loading="table.loading"
      class="table-section"
    >
      <div class="table-toolbar">
        <span class="table-toolbar__caption">
          {{ activeTabLabel }}记录 <strong>{{ table.total }}</strong> 条
        </span>
      </div>

      <el-table
        :data="table.list"
        border
        stripe
        style="width: 100%;"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="200"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="name-link"
              @click="handleOpenDetail(scope.row)"
            >
              {{ scope.row.budget_name || '--' }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="identify_code"
          label="识别名称"
          min-width="260"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.identify_names.length"
              class="tag-summary"
            >
              <el-tag
                type="success"
                class="tag-summary__first"
              >
                {{ scope.row.identify_names[0] }}
              </el-tag>
              <el-popover
                v-if="scope.row.identify_names.length > 1"
                placement="top"
                width="420"
                trigger="click"
              >
                <div class="tag-list-popover">
                  <el-tag
                    v-for="item in scope.row.identify_names"
                    :key="item"
                    type="success"
                  >
                    {{ item }}
                  </el-tag>
                </div>
                <el-button
                  slot="reference"
                  type="text"
                >
                  更多
                </el-button>
              </el-popover>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="owner_name"
          label="所属"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.owner_name || '--' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="source_label"
          label="进入方式"
          width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.source_label }}
          </template>
        </el-table-column>

        <el-table-column
          prop="start_time"
          label="进入客保时间"
          min-width="160"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.start_time || '--' }}
          </template>
        </el-table-column>

        <el-table-column
          prop="audit_status_label"
          label="审核状态"
          width="110"
        >
          <template slot-scope="scope">
            <el-tag
              :type="auditStatusTagType(scope.row.audit)"
              size="small"
            >
              {{ scope.row.audit_status_label }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="客保状态及期限"
          min-width="200"
        >
          <template slot-scope="scope">
            <div class="protect-cell">
              <div class="protect-cell__date">
                {{ scope.row.protect_deadline || '--' }}
              </div>
              <div
                :class="['protect-cell__sub', protectSubClass(scope.row)]"
              >
                {{ scope.row.protect_sub_text }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="126"
          fixed="right"
        >
          <template slot-scope="scope">
            <div class="row-actions">
              <el-button
                v-if="canAudit(scope.row) && canAdjust"
                type="primary"
                plain
                size="small"
                @click="handleOpenDetail(scope.row)"
              >
                审核
              </el-button>
              <el-button
                v-else
                type="text"
                size="small"
                @click="handleOpenDetail(scope.row)"
              >
                查看
              </el-button>
              <el-button
                v-if="canAdjust && canAdjustDeadline(scope.row)"
                type="text"
                size="small"
                @click="handleOpenAdjust(scope.row)"
              >
                调整客保期
              </el-button>
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="empty-wrap">
            <el-empty
              description="暂无数据"
              :image-size="100"
            />
          </div>
        </template>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="query.form.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="table.total"
        class="table-pagination"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- 审核通过 / 驳回 -->
    <el-dialog
      :title="auditDialog.form.action === 'approve' ? '审核通过' : '驳回审核'"
      :visible.sync="auditDialog.visible"
      width="520px"
      custom-class="audit-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div
        v-if="auditDialog.row"
        class="review-modal-object"
      >
        <strong>{{ auditDialog.row.budget_name }}</strong>
        <span>{{ auditDialog.row.identify_names_text }}</span>
      </div>

      <el-form
        ref="auditForm"
        :model="auditDialog.form"
        :rules="auditDialog.rules"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item
          v-if="auditDialog.form.action === 'approve'"
          label="正式客保开始时间"
        >
          <el-input
            value="审核通过时生效"
            readonly
          />
        </el-form-item>
        <el-form-item
          v-if="auditDialog.form.action === 'approve'"
          label="正式客保结束日期"
          prop="deadline"
        >
          <el-radio-group
            v-model="auditDialog.form.period"
            class="review-period-options"
          >
            <el-radio-button :label="1">1 个月</el-radio-button>
            <el-radio-button :label="2">2 个月</el-radio-button>
            <el-radio-button :label="3">3 个月</el-radio-button>
            <el-radio-button label="custom">自定义到期</el-radio-button>
          </el-radio-group>
          <div
            v-if="auditDialog.form.period !== 'custom'"
            class="review-period-preview"
          >
            预计结束日期 <strong>{{ approvalDeadline }}</strong>
          </div>
          <el-date-picker
            v-else
            v-model="auditDialog.form.deadline"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择正式客保结束日期"
            :picker-options="adjustPickerOptions"
            style="width: 100%; margin-top: 12px;"
          />
        </el-form-item>
        <el-form-item
          v-if="auditDialog.form.action === 'reject'"
          label="驳回原因"
          prop="reason"
        >
          <el-input
            v-model.trim="auditDialog.form.reason"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请填写需要归属人补充或修改的内容"
          />
        </el-form-item>
        <el-form-item
          v-else
          label="审核备注（选填）"
        >
          <el-input
            v-model.trim="auditDialog.form.reason"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入审核备注（最多 500 字）"
          />
        </el-form-item>
      </el-form>
      <div
        :class="['review-modal-note', { 'review-modal-note--warning': auditDialog.form.action === 'reject' }]"
      >
        <template v-if="auditDialog.form.action === 'approve'">
          通过后正式客保立即生效，截至所选日期当天结束，临时客保及旧到期任务将失效。
        </template>
        <template v-else>
          修改期为驳回成功时间 +2 天，预计截止：{{ rejectionDeadline }}。期间不触发默认 30 天到期掉公海；逾期未修改并提交才进入公海。
        </template>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="auditDialog.visible = false">
          取消
        </el-button>
        <el-button
          :type="auditDialog.form.action === 'approve' ? 'primary' : 'danger'"
          :loading="auditDialog.loading"
          @click="handleAuditSubmit"
        >
          {{ auditDialog.form.action === 'approve' ? '确认通过' : '确认驳回' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 审核详情 -->
    <el-drawer
      title="审核详情"
      :visible.sync="detailDialog.visible"
      direction="rtl"
      size="740px"
      custom-class="detail-drawer"
      append-to-body
    >
      <div
        v-if="detailDialog.row"
        class="review-detail-body"
      >
        <div class="review-detail-summary">
          <div>
            <h3>{{ detailDialog.row.budget_name }}</h3>
            <el-tag
              type="success"
              size="small"
            >
              {{ detailDialog.row.identify_names_text }}
            </el-tag>
          </div>
          <div class="review-detail-status">
            <el-tag
              :type="auditStatusTagType(detailDialog.row.audit)"
              size="small"
            >
              {{ detailDialog.row.audit_status_label }}
            </el-tag>
            <span>{{ detailDialog.row.protect_sub_text }}</span>
          </div>
        </div>
        <div
          :class="['review-detail-notice', `review-detail-notice--${detailNoticeKind}`]"
        >
          {{ detailNoticeText }}
        </div>
        <div class="review-detail-tabs">
          <button
            type="button"
            :class="{ 'is-active': detailDialog.tab === 'details' }"
            @click="detailDialog.tab = 'details'"
          >
            聚合资料
          </button>
          <button
            type="button"
            :class="{ 'is-active': detailDialog.tab === 'logs' }"
            @click="detailDialog.tab = 'logs'"
          >
            操作记录（{{ detailDialog.logs.length || 0}}）
          </button>
        </div>
        <template v-if="detailDialog.tab === 'details'">
          <section class="review-detail-section">
            <h4>聚合信息</h4>
            <dl class="review-detail-grid">
              <div><dt>聚合名称</dt><dd>{{ detailDialog.row.budget_name }}</dd></div>
              <div><dt>识别名称</dt><dd>{{ detailDialog.row.identify_names_text }}</dd></div>
              <div><dt>预算类型</dt><dd>直投</dd></div>
              <div><dt>所属</dt><dd>{{ detailDialog.row.owner_name }}</dd></div>
            </dl>
          </section>
          <section class="review-detail-section">
            <h4>客保信息</h4>
            <dl class="review-detail-grid">
              <div><dt>进入方式</dt><dd>{{ detailDialog.row.source_label }}</dd></div>
              <div><dt>客保状态</dt><dd>{{ detailDialog.row.protect_sub_text || '--' }}</dd></div>
              <div><dt>进入客保时间</dt><dd>{{ detailDialog.row.start_time }}</dd></div>
              <div><dt>{{ detailDeadlineLabel }}</dt><dd>{{ detailDialog.row.protect_deadline }}</dd></div>
              <div><dt>最近审核人</dt><dd>{{ detailDialog.row.audit_operator || '--' }}</dd></div>
              <div><dt>最近审核时间</dt><dd>{{ detailDialog.row.audit_time  || '--' }}</dd></div>
            </dl>
          </section>
          <section class="review-detail-section" 
            v-if="detailDialog.row.latest_operation_log && detailDialog.row.latest_operation_log.changes && detailDialog.row.latest_operation_log.changes.length > 0"
          >
            <h4>操作信息</h4>
            <dl class="review-detail-grid">
              <div><dt>操作人</dt><dd>{{ detailDialog.row.latest_operation_log && detailDialog.row.latest_operation_log.operator || '--' }}</dd></div>
              <div><dt>操作时间</dt><dd>{{ detailDialog.row.latest_operation_log && detailDialog.row.latest_operation_log.operation_time || '--' }}</dd></div>
            </dl>
            <el-table
              v-if="detailDialog.row.latest_operation_log && detailDialog.row.latest_operation_log.changes"
              :data="detailDialog.row.latest_operation_log.changes"
              border
              class="review-change-table"
            >
              <el-table-column
                prop="field"
                label="修改字段"
              />
              <el-table-column
                prop="before"
                label="修改前"
              />
              <el-table-column
                prop="after"
                label="修改后"
              />
            </el-table>
          </section>
        </template>
        <div
          v-else
          v-loading="detailDialog.loading"
          class="review-detail-timeline"
        >
          <div
            v-if="!detailDialog.logs.length"
            class="review-detail-empty"
          >
            暂无操作记录
          </div>
          <div
            v-for="(log, index) in detailDialog.logs"
            :key="index"
            class="review-detail-event"
          >
            <strong>{{ log.operation_info }}</strong>
            <time>{{ log.operation_time }}</time>
          </div>
        </div>
      </div>
      <div class="review-detail-footer" v-if="isAdmin">
        <!-- <span
          v-if="detailDialog.row && canAudit(detailDialog.row) && canAdjust"
          class="review-footer-meta"
        >
          仅超管可审核
        </span> -->
        <el-button
          v-if="!detailDialog.row || !canAudit(detailDialog.row) || !canAdjust"
          @click="detailDialog.visible = false"
        >
          关闭
        </el-button>
        <template v-if="detailDialog.row && canAudit(detailDialog.row) && canAdjust">
          <el-button
            type="danger"
            plain
            @click="handleOpenAudit(detailDialog.row, 'reject')"
          >
            驳回
          </el-button>
          <el-button
            type="primary"
            @click="handleOpenAudit(detailDialog.row, 'approve')"
          >
            通过
          </el-button>
        </template>
        <el-button
          v-if="detailDialog.row && canAdjust && canAdjustDeadline(detailDialog.row)"
          type="primary"
          @click="handleOpenAdjust(detailDialog.row)"
        >
          调整客保期
        </el-button>
      </div>
    </el-drawer>

    <!-- 调整客保期弹窗（已通过） -->
    <el-dialog
      title="调整客保期"
      :visible.sync="adjustDialog.visible"
      width="520px"
      custom-class="adjust-dialog"
      append-to-body
      :close-on-click-modal="false"
    >
      <div
        v-if="adjustDialog.row"
        class="review-modal-object"
      >
        <strong>{{ adjustDialog.row.budget_name || '--' }}</strong>
        <span>当前到期：{{ adjustDialog.row.protect_deadline || '--' }}</span>
      </div>
      <el-form
        ref="adjustForm"
        :model="adjustDialog.form"
        :rules="adjustDialog.rules"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item
          label="新的到期日期"
          prop="deadline"
        >
          <el-date-picker
            v-model="adjustDialog.form.deadline"
            type="date"
            placeholder="请选择新的到期日期"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
            :picker-options="adjustPickerOptions"
          />
        </el-form-item>
        <el-form-item
          label="调整原因"
          prop="reason"
        >
          <el-input
            v-model.trim="adjustDialog.form.reason"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请填写调整客保期的原因"
          />
        </el-form-item>
      </el-form>
      <div class="review-modal-note">
        正式开始时间保持不变，客保截至所选日期当天结束，同步更新提醒计划。
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="adjustDialog.visible = false">
          取消
        </el-button>
        <el-button
          type="primary"
          :loading="adjustDialog.loading"
          @click="handleAdjustSubmit"
        >
          确认调整
        </el-button>
      </div>
    </el-dialog>

    <!-- 操作日志抽屉 -->
    <el-drawer
      title="操作日志"
      :visible.sync="logDialog.visible"
      direction="rtl"
      size="1080px"
      custom-class="log-drawer"
      append-to-body
    >
      <div class="log-filters">
        <el-form
            :inline="true"
            @submit.native.prevent
          >
            <el-form-item label="聚合名称">
              <el-input
                v-model.trim="logDialog.form.budget_name"
                clearable
                placeholder="请输入聚合名称"
                @keyup.enter.native="handleLogFilter"
              />
            </el-form-item>
            <el-form-item
              label="操作时间"
              style="margin-left: 24px;"
            >
              <el-date-picker
                v-model="logDialog.form.date_range"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                clearable
              />
            </el-form-item>
          </el-form>
        <div>
          <el-button
            plain
            @click="handleResetLogFilter"
          >
            重置
          </el-button>
          <el-button
            type="primary"
            @click="handleLogFilter"
          >
            查询
          </el-button>
        </div>
      </div>

      <el-table
        v-loading="logDialog.loading"
        :data="logDialog.list"
        border
        stripe
      >
        <el-table-column
          prop="operation_time"
          label="操作时间"
          width="160"
        />
        <el-table-column
          prop="budget_name"
          label="聚合名称"
          min-width="160"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.budget_name || '--' }}</div>
            <div
              v-if="scope.row.identify_code"
              class="log-subline"
            >
              {{ scope.row.identify_code }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation_info"
          label="操作信息"
          min-width="220"
        />
        <el-table-column
          prop="operator"
          label="操作人"
          width="120"
        />
        <template slot="empty">
          <div class="empty-wrap">
            <el-empty
              description="暂无数据"
              :image-size="80"
            />
          </div>
        </template>
      </el-table>

      <el-pagination
        :current-page.sync="logDialog.form.page"
        :page-sizes="[10, 20, 50]"
        :page-size="logDialog.form.page_size"
        layout="total, sizes, prev, pager, next"
        :total="logDialog.total"
        class="table-pagination"
        @size-change="handleLogPageSizeChange"
        @current-change="handleLogPageChange"
      />
    </el-drawer>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import queryGridByContainer from '@/common/js/queryGridByContainer';
import {
  mockGroupList,
  mockLog,
  mockExpire,
  mockReview,
  mockAdjustDeadline,
} from './DirectCustomerReview.mock';

const req = new Request();

// 前端联调开关：后端就绪后置为 false 即可切回真实接口
const USE_MOCK = false;

// 审核状态：0=待审核 2=已驳回 1=已通过
const AUDIT_STATUS_PENDING = 0;
const AUDIT_STATUS_REJECTED = 2;
const AUDIT_STATUS_APPROVED = 1;

const AUDIT_STATUS_MAP = {
  [AUDIT_STATUS_PENDING]: '待审核',
  [AUDIT_STATUS_REJECTED]: '已驳回',
  [AUDIT_STATUS_APPROVED]: '已通过',
};

const AUDIT_STATUS_TAG_TYPE = {
  [AUDIT_STATUS_PENDING]: 'warning',
  [AUDIT_STATUS_REJECTED]: 'danger',
  [AUDIT_STATUS_APPROVED]: 'success',
};

// 进入方式：0=新创建 1=公海认领
const SOURCE_OPTIONS = [
  { label: '新创建', value: 0 },
  { label: '公海认领', value: 1 },
];

const SOURCE_MAP = {
  0: '新创建',
  1: '公海认领',
};

// 客保状态：1=默认保护 2=修改期保护 3=正式保护
const PROTECT_STATUS_OPTIONS = [
  { label: '默认保护', value: 0 },
  { label: '修改期保护', value: 2 },
  { label: '正式保护', value: 1 },
];

const PROTECT_STATUS_MAP = {
  0: '默认保护',
  2: '修改期保护',
  1: '正式保护',
};

const TABS = [
  { key: 'pending', label: '待审核', value: AUDIT_STATUS_PENDING },
  { key: 'rejected', label: '已驳回', value: AUDIT_STATUS_REJECTED },
  { key: 'approved', label: '已通过', value: AUDIT_STATUS_APPROVED },
  { key: 'all', label: '全部', value: -1 },
];

function hasValue(value) {
  if (value === 0 || value === '0' || value === false) return true;
  if (value === undefined || value === null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

function safeTrim(value) {
  if (typeof value === 'string') return value.trim();
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function formatDate(date) {
  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

function daysRemaining(date) {
  return Math.max(0, Math.ceil((new Date(`${date}T23:59:59`) - new Date()) / 86400000));
}

function splitTextList(value) {
  if (Array.isArray(value)) {
    return value.map((item) => safeTrim(item)).filter(Boolean);
  }

  const text = safeTrim(value);
  if (!text) return [];

  return text
    .replace(/[，、；;]/g, ',')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

function pickValue(is_claim = {}, keys = []) {
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    if (
      Object.prototype.hasOwnProperty.call(is_claim, key) &&
      hasValue(is_claim[key])
    ) {
      return is_claim[key];
    }
  }
  return '';
}

function createDefaultQuery() {
  return {
    page: 1,
    page_size: 10,
    budget_name: '',
    identify_code: '',
    owner_name: '',
    is_claim: '',
    protect_status: '',
    start_time: [],
  };
}

export default {
  name: 'DirectCustomerReview',
  mixins: [queryGridByContainer],
  data() {
    return {
      tabs: TABS,
      activeTab: 'pending',
      tabCounts: {
        pending: 0,
        rejected: 0,
        approved: 0,
        all: 0,
      },
      queryExpanded: true,
      query: {
        form: createDefaultQuery(),
      },
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      auditDialog: {
        visible: false,
        loading: false,
        row: null,
        form: {
          action: 'approve',
          reason: '',
          period: 1,
          deadline: '',
        },
        rules: {
          reason: [
            { required: true, message: '请输入驳回原因', trigger: 'blur' },
          ],
          deadline: [
            {
              validator: (rule, value, callback) => {
                if (this.auditDialog.form.period !== 'custom' || value) callback();
                else callback(new Error('请选择正式客保结束日期'));
              },
              trigger: 'change',
            },
          ],
        },
      },
      logDialog: {
        visible: false,
        loading: false,
        list: [],
        total: 0,
        form: {
          budget_name: '',
          date_range: [],
          page: 1,
          page_size: 10,
        },
      },
      detailDialog: {
        visible: false,
        row: null,
        tab: 'details',
        logs: [],
        loading: false,
      },
      adjustDialog: {
        visible: false,
        loading: false,
        row: null,
        form: {
          deadline: '',
          reason: '',
        },
        rules: {
          deadline: [
            {
              required: true,
              message: '请选择新的客保到期时间',
              trigger: 'change',
            },
          ],
          reason: [
            { required: true, message: '请输入调整原因', trigger: 'blur' },
          ],
        },
      },
      userInfo: {},
      expireNotice: {
        list: [],
        currentIndex: 0,
        animating: false,
        timer: null,
      },
    };
  },
  computed: {
    isAdmin() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1")
      }
      return false
    },
    sourceOptions() {
      return SOURCE_OPTIONS;
    },

    protectStatusOptions() {
      return PROTECT_STATUS_OPTIONS;
    },

    activeTabLabel() {
      const hit = this.tabs.find((item) => item.key === this.activeTab);
      return hit ? hit.label : '';
    },

    activeAuditStatus() {
      const hit = this.tabs.find((item) => item.key === this.activeTab);
      return hit ? hit.value : '';
    },

    tabCountsText() {
      return {
        pending: this.tabCounts.pending,
        rejected: this.tabCounts.rejected,
        approved: this.tabCounts.approved,
        all: this.tabCounts.all,
      };
    },

    approvalDeadline() {
      if (this.auditDialog.form.period === 'custom') return this.auditDialog.form.deadline;
      const today = new Date();
      const day = today.getDate();
      today.setDate(1);
      today.setMonth(today.getMonth() + Number(this.auditDialog.form.period));
      today.setDate(Math.min(day, new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()));
      return formatDate(today);
    },

    rejectionDeadline() {
      const date = new Date();
      date.setDate(date.getDate() + 2);
      return formatDate(date);
    },

    detailNoticeKind() {
      const row = this.detailDialog.row || {};
      if (Number(row.remaining_days) <= 0) return 'info';
      if (Number(row.audit) === AUDIT_STATUS_REJECTED) return 'warning';
      if (Number(row.audit) === AUDIT_STATUS_APPROVED) return 'success';
      return 'info';
    },

    detailNoticeText() {
      const row = this.detailDialog.row || {};
      if (Number(row.remaining_days) <= 0) {
        return row.audit_reason || '客保已到期释放，聚合已回到公海。';
      }
      if (Number(row.audit) === AUDIT_STATUS_REJECTED) {
        return `驳回原因：${row.audit_reason || '--'}。修改截止：${row.protect_deadline}，2 天内需修改并重新提交。`;
      }
      if (Number(row.audit) === AUDIT_STATUS_APPROVED) {
        return `正式客保已生效，到期时间 ${row.protect_deadline}。`;
      }
      return `默认客保为进入客保成功时间 +30 天，当前到期时间 ${row.protect_deadline}。通过后以实际设置的正式期限为准。`;
    },

    detailDeadlineLabel() {
      const audit = Number((this.detailDialog.row || {}).audit);
      if (audit === AUDIT_STATUS_REJECTED) return '修改截止时间';
      if (audit === AUDIT_STATUS_APPROVED) return '正式到期时间';
      return '默认到期时间';
    },

    // 是否为超管（role_ids 含 "1"）：已通过记录可「调整客保期」
    canAdjust() {
      if (this.userInfo && Array.isArray(this.userInfo.role_ids)) {
        return this.userInfo.role_ids.some((id) => Number(id) === 1);
      }
      return false;
    },

    adjustPickerOptions() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return {
        disabledDate(date) {
          return date.getTime() < today.getTime();
        },
      };
    },

    // ===== 搜索栏响应式栅格（参照 AggregationReport/Index.vue）=====
    queryColumnsPerRow() {
      return Math.max(24 / this.queryColSpan, 1);
    },

    collapsedQueryCount() {
      return Math.min(
        Math.max(this.queryColumnsPerRow - 1, 1),
        this.queryFieldKeys.length,
      );
    },

    visibleQueryFieldCount() {
      return this.queryExpanded
        ? this.queryFieldKeys.length
        : this.collapsedQueryCount;
    },

    queryActionSpan() {
      const remainder = this.visibleQueryFieldCount % this.queryColumnsPerRow;
      const remainingColumns =
        remainder === 0
          ? this.queryColumnsPerRow
          : this.queryColumnsPerRow - remainder;

      return remainingColumns * this.queryColSpan;
    },

    queryFieldKeys() {
      return [
        'budget_name',
        'identify_code',
        'owner_name',
        'is_claim',
        // 'protect_status',
      ];
    },

    queryFieldVisibility() {
      const visibility = {};
      this.queryFieldKeys.forEach((key, index) => {
        visibility[key] = index < this.visibleQueryFieldCount;
      });
      return visibility;
    },

    showQueryToggle() {
      return this.queryFieldKeys.length > this.collapsedQueryCount;
    },

    // ===== 客保到期提醒 =====
    showExpireNotice() {
      return this.expireNotice.list.length > 0;
    },

    hasMultipleExpireNotice() {
      return this.expireNotice.list.length > 1;
    },

    currentExpireNotice() {
      return (
        this.expireNotice.list[this.expireNotice.currentIndex] || { text: '' }
      );
    },

    nextExpireNotice() {
      if (!this.hasMultipleExpireNotice) {
        return this.currentExpireNotice;
      }
      const nextIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      return this.expireNotice.list[nextIndex] || { text: '' };
    },

    expireNoticeTrackStyle() {
      return {
        transform: this.expireNotice.animating
          ? 'translateY(-44px)'
          : 'translateY(0)',
      };
    },
  },
  created() {
    this.getUserInfo();
    this.getList();
    this.getExpireNotice();
  },
  beforeDestroy() {
    this.clearExpireNoticeTimer();
  },
  methods: {
    // ===== 搜索栏交互 =====
    toggleQueryExpand() {
      this.queryExpanded = !this.queryExpanded;
    },

    buildListParams() {
      const form = this.query.form;
      const params = {
        ...form,
        page: Number(form.page) || 1,
        page_size: Number(form.page_size) || 10,
        // 直投聚合客保审核页：固定直投 + 客保视图
      };

      if (hasValue(this.activeAuditStatus)) {
        params.audit = this.activeAuditStatus;
      }

      if (hasValue(form.budget_name)) {
        params.budget_name = form.budget_name;
      }
      if (hasValue(form.identify_code)) {
        params.identify_code = form.identify_code;
      }
      if (hasValue(form.owner_name)) {
        params.owner_name = form.owner_name;
      }
      if (hasValue(form.is_claim)) {
        params.is_claim = form.is_claim;
      }
      if (hasValue(form.protect_status)) {
        params.protect_status = form.protect_status;
      }
      if (Array.isArray(form.start_time) && form.start_time.length === 2) {
        params.enter_time_start = form.start_time[0];
        params.enter_time_end = form.start_time[1];
      }

      return params;
    },

    normalizeRow(row = {}) {
      const identifyNames = splitTextList(pickValue(row, ['identify_code', 'identify_names']));
      const auditStatus = safeTrim(pickValue(row, ['audit']));
      const is_claim = safeTrim(pickValue(row, ['is_claim']));
      const protectStatus = safeTrim(pickValue(row, ['protect_status']));
      const protectDeadline = pickValue(row, ['end_time']);
      const remainingDays = pickValue(row, ['remaining_days']);

      return {
        ...row,
        id: pickValue(row, ['id', 'config_id', 'group_id']),
        budget_name:
          pickValue(row, ['budget_name', 'aggregation_name']) || '--',
        identify_names: identifyNames,
        identify_names_text: identifyNames.join('、') || '--',
        owner_name: pickValue(row, ['owner_name', 'owner_names']) || '--',
        source_label: SOURCE_MAP[is_claim] || '--',
        start_time:
          pickValue(row, ['start_time', 'status_time', 'protect_time']) || '--',
        audit: auditStatus,
        audit_status_label:
          AUDIT_STATUS_MAP[auditStatus] || (auditStatus ? auditStatus : '--'),
        protect_deadline: protectDeadline || '--',
        protect_sub_text: this.buildProtectSubText(
          auditStatus,
          remainingDays,
        ),
        protect_sub_kind: this.buildProtectSubKind(
          auditStatus,
          remainingDays,
        ),
        latest_operation_log: row.latest_operation_log || {}
      };
    },

    buildProtectSubText(protectStatus, remainingDays) {
      const statusLabel = PROTECT_STATUS_MAP[protectStatus] || '';
      if (hasValue(remainingDays)) {
        const days = Number(remainingDays);
        const remainText = Number.isNaN(days)
          ? safeTrim(remainingDays)
          : `剩余 ${days} 天`;
        return statusLabel ? `${statusLabel} · ${remainText}` : remainText;
      }
      return statusLabel || '';
    },

    buildProtectSubKind(protectStatus, remainingDays) {
      if (protectStatus === '2' || protectStatus === 2) return 'danger'
      const days = Number(remainingDays);
      if (!Number.isNaN(days) && days <= 3) {
        return 'warning';
      }
      return 'blue';
    },

    protectSubClass(row) {
      return `protect-cell__sub--${row.protect_sub_kind || 'blue'}`;
    },

    auditStatusTagType(status) {
      return AUDIT_STATUS_TAG_TYPE[status] || 'info';
    },

    canAudit(row) {
      return Number(row.audit) === AUDIT_STATUS_PENDING;
    },

    // 已通过且客保仍有效（剩余天数 > 0）可调整客保期
    canAdjustDeadline(row) {
      return (
        Number(row.audit) === AUDIT_STATUS_APPROVED &&
        Number(row.remaining_days) > 0
      );
    },

    async getUserInfo() {
      try {
        const res = await req.send(req.Apis.sales.user.userInfo);
        if (res.code === 200) {
          this.userInfo = res.data || {};
        }
      } catch (err) {
        // 获取用户信息失败不阻塞主流程
      }
    },

    // ===== 列表查询 =====
    async getList() {
      try {
        this.table.loading = true;
        const params = this.buildListParams();
        const res = USE_MOCK
          ? await mockGroupList(params)
          : await req
              .send(req.Apis.customer.aggregation.customerReviewList, params)
              .fin(() => {
                this.table.loading = false;
              });

        const data = res.data || {};

        if (data.counts && typeof data.counts === 'object') {
          this.tabCounts = { ...this.tabCounts, ...data.counts };
        }

        const list = data.list || data.data || [];
        this.table.list = (Array.isArray(list) ? list : []).map((item) =>
          this.normalizeRow(item),
        );
        this.table.total = Number(data.total || this.table.list.length || 0);
        this.table.loading = false;
      } catch (err) {
        this.table.loading = false;
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    handleFilter() {
      this.query.form.page = 1;
      this.getList();
    },

    handleReset() {
      this.query.form = createDefaultQuery();
      this.query.form.page = 1;
      this.getList();
    },

    handleTabChange(key) {
      if (this.activeTab === key) return;
      this.activeTab = key;
      this.query.form.page = 1;
      this.getList();
    },

    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize) || 10;
      this.query.form.page = 1;
      this.getList();
    },

    handleQueryPage(page) {
      this.query.form.page = Number(page) || 1;
      this.getList();
    },

    handleDetail(row) {
      // 跳转聚合详情（复用我的聚合详情路由）
      if (!row.id) return;
      const url = this.$router.resolve({
        path: '/aggregation-manage/my',
        query: { id: row.id },
      });
      window.open(url.href, '_blank');
    },

    // ===== 审核流程 =====
    handleOpenAudit(row, action = 'approve') {
      this.auditDialog.row = row;
      this.auditDialog.form.action = action;
      this.auditDialog.form.reason = '';
      this.auditDialog.form.period = 1;
      this.auditDialog.form.deadline = '';
      this.auditDialog.form.note = '';
      this.auditDialog.visible = true;
      this.$nextTick(() => {
        if (this.$refs.auditForm) {
          this.$refs.auditForm.clearValidate();
        }
      });
    },

    handleAuditSubmit() {
      if (!this.$refs.auditForm) return;
      this.$refs.auditForm.validate(async (valid) => {
        if (!valid) return;
        const row = this.auditDialog.row || {};
        const isApprove = this.auditDialog.form.action === 'approve';
        const params = {
          budget_id: row.budget_id,
          audit: isApprove
            ? AUDIT_STATUS_APPROVED
            : AUDIT_STATUS_REJECTED,
        };

        if (!isApprove) {
          params.reason = this.auditDialog.form.reason;
        } else {
          params.end_date = this.approvalDeadline;
          if (this.auditDialog.form.reason) params.reason = this.auditDialog.form.reason;
        }

        try {
          this.auditDialog.loading = true;
          if (USE_MOCK) {
            await mockReview({ ...params, operator: this.userInfo.name || this.userInfo.user_name });
          } else {
            let res = await req
              .send(req.Apis.customer.aggregation.protectAuditReview, params)
              .fin(() => {
                this.auditDialog.loading = false;
              });
            
            if (res.code === 200) {
              this.auditDialog.loading = false;
              this.$message.success(isApprove ? '审核已通过' : '已驳回');
              this.auditDialog.visible = false;
              if (this.detailDialog.visible) {
                await this.refreshDetailDrawer(row.budget_id);
              }
              this.getList();
              this.getExpireNotice();
            } else {
              this.$message.error(res.message)
            }
          }
        } catch (err) {
          this.auditDialog.loading = false;
          // this.$message.error(`审核失败：${err.message || '未知错误'}`);
        }
      });
    },

    // ===== 查看（已驳回 / 已通过）=====
    async handleOpenDetail(row) {
      if (USE_MOCK) {
        this.detailDialog.row = row;
        this.detailDialog.tab = 'details';
        this.detailDialog.logs = [];
        this.detailDialog.visible = true;
        this.getDetailLogs(row);
      } else {
        this.table.loading = true;
        const params = {
          budget_id: row.budget_id
        }
        const res = await req
          .send(req.Apis.customer.aggregation.customerReviewDetail, params)
          .fin(() => {
            this.table.loading = false;
          });
        if (res.code === 200) {
          const data = this.normalizeRow(res.data);
          this.detailDialog.row = data;
          this.detailDialog.tab = 'details';
          this.detailDialog.logs = data.logs.list;
          this.detailDialog.visible = true;
        } else {
          this.$message.error(res.message)
        }
      }      
    },

    async refreshDetailDrawer(budgetId) {
      if (!this.detailDialog.visible ||
          String((this.detailDialog.row || {}).budget_id) !== String(budgetId)) return;

      this.detailDialog.loading = true;
      try {
        const res = await req.send(req.Apis.customer.aggregation.customerReviewDetail, {
          budget_id: budgetId,
        });
        if (res.code !== 200) {
          this.$message.error(res.message || '获取详情失败');
          return;
        }
        if (!this.detailDialog.visible ||
            String((this.detailDialog.row || {}).budget_id) !== String(budgetId)) return;

        const data = res.data || {};
        this.detailDialog.row = this.normalizeRow(data);
        this.detailDialog.logs = (data.logs && data.logs.list) || [];
      } catch (err) {
        this.$message.error(`获取详情失败：${err.message || '未知错误'}`);
      } finally {
        this.detailDialog.loading = false;
      }
    },

    async getDetailLogs(row) {
      this.detailDialog.loading = true;
      try {
        const params = { budget_name: row.budget_name, page: 1, page_size: 100 };
        const res = USE_MOCK
          ? await mockLog(params)
          : await req.send(req.Apis.customer.aggregation.customerReviewLogList, params);
        if (this.detailDialog.row !== row) return;
        const data = res.data || {};
        const list = data.list || data.data || [];
        this.detailDialog.logs = (Array.isArray(list) ? list : [])
          .filter((item) => item.budget_name === row.budget_name)
          .map((item) => this.normalizeLogRow(item));
      } catch (err) {
        if (this.detailDialog.row === row) this.$message.error('获取操作记录失败');
      } finally {
        if (this.detailDialog.row === row) this.detailDialog.loading = false;
      }
    },

    // ===== 调整客保期（已通过）=====
    handleOpenAdjust(row) {
      this.adjustDialog.row = row;
      this.adjustDialog.form.deadline = row.protect_deadline || '';
      this.adjustDialog.form.reason = '';
      this.adjustDialog.visible = true;
      this.$nextTick(() => {
        if (this.$refs.adjustForm) {
          this.$refs.adjustForm.clearValidate();
        }
      });
    },

    handleAdjustSubmit() {
      if (!this.$refs.adjustForm) return;
      this.$refs.adjustForm.validate(async (valid) => {
        if (!valid) return;
        const row = this.adjustDialog.row || {};
        const params = {
          budget_id: row.budget_id,
          end_date: this.adjustDialog.form.deadline,
          reason: this.adjustDialog.form.reason,
        };

        try {
          this.adjustDialog.loading = true;
          if (USE_MOCK) {
            await mockAdjustDeadline({ ...params, operator: this.userInfo.name || this.userInfo.user_name });
            this.adjustDialog.loading = false;
            this.adjustDialog.visible = false;
            this.$message.success('客保期已调整');
            
            if (this.detailDialog.visible) {
              this.detailDialog.row = this.normalizeRow({
                ...row,
                end_time: params.end_date ? `${params.end_date} 00:00:00` : '--',
                remaining_days: daysRemaining(params.end_date) - 1,
              });
              this.getDetailLogs(this.detailDialog.row);
            }
          } else {
            let res = await req
              .send(req.Apis.customer.aggregation.protectAuditAdjust, params)
              .fin(() => {
                this.adjustDialog.loading = false;
              });

            this.adjustDialog.loading = false;
            if (res.code === 200) {
              this.$message.success('客保期已调整');
              this.adjustDialog.visible = false;
              if (this.detailDialog.visible) {
                await this.refreshDetailDrawer(row.budget_id);
              }

              this.getList();
              this.getExpireNotice();
            } else {
              this.$message.error(res.message);
            }
          }
          
        } catch (err) {
          this.adjustDialog.loading = false;
          this.$message.error(`调整失败：${err.message || '未知错误'}`);
        }
      });
    },

    // ===== 操作日志 =====
    buildLogParams() {
      const form = this.logDialog.form;
      const params = {
        page: Number(form.page) || 1,
        page_size: Number(form.page_size) || 10,
      };
      if (hasValue(form.budget_name)) {
        params.budget_name = form.budget_name;
      }
      if (Array.isArray(form.date_range) && form.date_range.length === 2) {
        params.start_date = form.date_range[0];
        params.end_date = form.date_range[1];
      }
      return params;
    },

    async getLogList() {
      try {
        this.logDialog.loading = true;
        const params = this.buildLogParams();
        const res = USE_MOCK
          ? await mockLog(params)
          : await req.send(req.Apis.customer.aggregation.customerReviewLogList, params).fin(() => {
              this.logDialog.loading = false;
            });

        const data = res.data || {};
        const list = data.list || data.data || [];
        this.logDialog.list = (Array.isArray(list) ? list : []).map((item) =>
          this.normalizeLogRow(item),
        );
        this.logDialog.total = Number(
          data.total || this.logDialog.list.length || 0,
        );
        this.logDialog.loading = false;
      } catch (err) {
        this.logDialog.loading = false;
        this.$message.error(`获取操作日志失败：${err.message || '未知错误'}`);
      }
    },

    normalizeLogRow(row = {}) {
      return {
        ...row,
        operation_time: pickValue(row, ['operation_time']) || '--',
        budget_name:  pickValue(row, ['budget_name']) || '--',
        identify_code: pickValue(row, ['identify_code']),
        operation_info: pickValue(row, ['operation_info']) || '--',
        operator: pickValue(row, ['operator']) || '--',
      };
    },

    handleOpenLogDrawer() {
      this.logDialog.form.page = 1;
      this.logDialog.visible = true;
      this.getLogList();
    },

    handleLogFilter() {
      this.logDialog.form.page = 1;
      this.getLogList();
    },

    handleResetLogFilter() {
      this.logDialog.form.budget_name = '';
      this.logDialog.form.date_range = [];
      this.logDialog.form.page = 1;
      this.getLogList();
    },

    handleLogPageSizeChange(pageSize) {
      this.logDialog.form.page_size = Number(pageSize) || 10;
      this.logDialog.form.page = 1;
      this.getLogList();
    },

    handleLogPageChange(page) {
      this.logDialog.form.page = Number(page) || 1;
      this.getLogList();
    },

    // ===== 客保到期提醒 =====
    async getExpireNotice() {
      if (USE_MOCK) {
        try {
          const res = await mockExpire();
          const data = res.data || {};
          const list = data.list || [];
          this.expireNotice.list = (Array.isArray(list) ? list : [])
            .map((item) => this.normalizeExpireNoticeRow(item))
            .filter((item) => hasValue(item.text));
          this.expireNotice.currentIndex = 0;
          this.expireNotice.animating = false;
          this.startExpireNoticeTimer();
        } catch (err) {
          this.expireNotice.list = [];
          this.clearExpireNoticeTimer();
        }
        return;
      }

      try {
        const res = await req.send(req.Apis.customer.aggregation.budgetExpire, {
          type: 1,
          page: 1,
          page_size: 100,
        });
        const data = res.data || {};
        const list = data.list || data.data || [];
        this.expireNotice.list = (Array.isArray(list) ? list : [])
          .map((item) => this.normalizeExpireNoticeRow(item))
          .filter((item) => hasValue(item.text));
        this.expireNotice.currentIndex = 0;
        this.expireNotice.animating = false;
        this.startExpireNoticeTimer();
      } catch (err) {
        this.expireNotice.list = [];
        this.expireNotice.currentIndex = 0;
        this.expireNotice.animating = false;
        this.clearExpireNoticeTimer();
      }
    },

    normalizeExpireNoticeRow(row = {}) {
      const budgetName =
        pickValue(row, ['budget_name', 'aggregation_name']) || '--';
      const releaseTime =
        pickValue(row, ['release_time', 'protect_deadline']) || '--';
      const remainingText =
        pickValue(row, ['remaining_text']) ||
        (hasValue(row.remaining_days) ? `剩余${row.remaining_days}天` : '');

      return {
        ...row,
        text: `【客保期提醒】聚合「${budgetName}」将于 ${releaseTime} 到期，${remainingText}，请及时处理，到期后该聚合将进入公海客户池。`,
      };
    },

    startExpireNoticeTimer() {
      this.clearExpireNoticeTimer();
      if (!this.hasMultipleExpireNotice) return;
      this.expireNotice.timer = setInterval(() => {
        if (this.expireNotice.animating) return;
        this.expireNotice.animating = true;
      }, 3000);
    },

    clearExpireNoticeTimer() {
      if (this.expireNotice.timer) {
        clearInterval(this.expireNotice.timer);
        this.expireNotice.timer = null;
      }
    },

    handleExpireNoticeTransitionEnd() {
      if (!this.expireNotice.animating || !this.hasMultipleExpireNotice) return;
      this.expireNotice.currentIndex =
        (this.expireNotice.currentIndex + 1) % this.expireNotice.list.length;
      this.expireNotice.animating = false;
    },
  },
};
</script>

<style lang="less" scoped>
.direct-customer-review-page {
  min-width: 0;
}

// ===== 客保到期提醒 =====
.expire-notice {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 16px;
  height: 44px;
  border-radius: 8px;
  background: linear-gradient(90deg, #fff4e8 0%, #fffaf5 100%);
  border: 1px solid #ffd3a8;
  box-shadow: 0 4px 12px rgba(230, 106, 0, 0.08);
}

.expire-notice__icon {
  flex: 0 0 auto;
  margin-right: 12px;
  color: #e67a00;
  font-size: 18px;
}

.expire-notice__viewport {
  flex: 1;
  height: 44px;
  overflow: hidden;
}

.expire-notice__track {
  will-change: transform;
}

.expire-notice__track.is-animating {
  transition: transform 0.45s ease;
}

.expire-notice__item {
  display: flex;
  align-items: center;
  height: 44px;
  color: #d14b00;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

// ===== 页面标题 =====
.page-heading {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 16px;
}

.page-heading__title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #303133;
}

.page-heading__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

// ===== 状态 Tab =====
.status-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.status-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  font-size: 14px;
  line-height: 20px;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 18px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #2f9eff;
    border-color: #a9d4ff;
  }

  &.is-active {
    color: #fff;
    background: #2f9eff;
    border-color: #2f9eff;
  }
}

.status-tab__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  font-size: 12px;
  border-radius: 9px;
  background: rgba(0, 0, 0, 0.08);
  color: inherit;

  .status-tab.is-active & {
    background: rgba(255, 255, 255, 0.25);
  }
}

// ===== 搜索栏 =====
.query-conditions {
  margin-bottom: 20px;
  padding: 20px 20px 8px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.query-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}

.query-row {
  flex: 1 1 720px;
}

.query-item {
  margin-bottom: 12px;
}

.query-item--actions {
  display: flex;
  align-items: flex-start;
}

.query-buttons {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.query-toggle {
  padding: 0;
}

// ===== 表格 =====
.table-section {
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 14px;
  color: #606266;

  strong {
    color: #2f9eff;
    font-weight: 600;
  }
}

.table-pagination {
  margin-top: 24px;
  text-align: right;
}

.name-link {
  padding: 0;
  font-size: 14px;
}

.tag-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.tag-summary__first {
  max-width: calc(100% - 52px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tag-list-popover {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 240px;
  overflow-y: auto;
}

.protect-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;

  &__date {
    font-size: 14px;
    color: #303133;
  }

  &__sub {
    font-size: 12px;
    line-height: 18px;

    &--blue {
      color: #2f9eff;
    }

    &--danger {
      color: #f56c6c;
    }

    &--warning {
      color: #e6a23c;
    }
  }
}

.empty-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

// ===== 审核弹窗 =====
.audit-summary {
  margin-bottom: 20px;
  padding: 16px 20px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.audit-summary__row {
  display: flex;
  align-items: flex-start;
  padding: 4px 0;
  font-size: 14px;
  line-height: 22px;
}

.audit-summary__label {
  flex: 0 0 110px;
  color: #909399;
}

.audit-summary__value {
  flex: 1;
  color: #303133;
  word-break: break-all;
}

.protect-sub-inline {
  font-size: 12px;

  &.protect-cell__sub--warning {
    color: #e6a23c;
  }

  &.protect-cell__sub--danger {
    color: #F56c6c;
  }

  &.protect-cell__sub--blue {
    color: #2f9eff;
  }
}

// ===== 行操作按钮 =====
.row-actions {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;

  /deep/ .el-button + .el-button {
    margin-left: 0;
  }

  /deep/ .el-button--text {
    padding: 4px 0;
  }
}

// ===== 调整客保期弹窗 =====
.adjust-target {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  font-size: 14px;
  line-height: 22px;
}

.adjust-target__label {
  flex: 0 0 80px;
  color: #909399;
}

.adjust-target__value {
  flex: 1;
  color: #303133;
  font-weight: 500;
}

.adjust-current {
  color: #2f9eff;
  font-size: 14px;
}

// ===== 操作日志抽屉 =====
.log-filters {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

.log-subline {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
}

/deep/ .query-conditions .el-form-item {
  display: block;
  margin-right: 0;
  margin-bottom: 0;
}

/deep/ .query-conditions .el-form-item__content {
  display: block;
}

/deep/ .query-buttons .el-button + .el-button {
  margin-left: 0;
}

@media screen and (max-width: 767px) {
  .table-section,
  .query-conditions {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>

<style lang="less">
.detail-drawer {
  max-width: 100vw;

  .el-drawer__header {
    margin: 0;
    padding: 20px 28px;
    border-bottom: 1px solid #e7edf5;
    color: #303740;
    font-size: 18px;
  }

  .el-drawer__body {
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .review-detail-body {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 25px 28px;
  }

  .review-detail-summary {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 21px;

    h3 {
      margin: 0 0 7px;
      font-size: 20px;
      font-weight: 500;
      color: #353e46;
    }

    .el-tag {
      max-width: 390px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .review-detail-status {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    white-space: nowrap;
    font-size: 12px;
    color: #909399;
  }

  .review-detail-notice {
    margin-bottom: 22px;
    padding: 12px 14px;
    border: 1px solid #d9eafd;
    border-radius: 4px;
    background: #eff7ff;
    color: #5d94c6;
    font-size: 12px;
    line-height: 1.8;
    overflow-wrap: anywhere;

    &--warning {
      border-color: #ffcc97;
      background: #fff9f2;
      color: #e66e18;
    }

    &--success {
      border-color: #dcf0ce;
      background: #f3faed;
      color: #659a45;
    }
  }

  .review-detail-tabs {
    display: flex;
    gap: 29px;
    margin-bottom: 24px;
    border-bottom: 1px solid #e7edf5;

    button {
      position: relative;
      padding: 10px 0 13px;
      border: 0;
      background: none;
      color: #606266;
      cursor: pointer;
      font-size: 14px;
    }

    button.is-active {
      color: #409eff;

      &::after {
        position: absolute;
        right: 0;
        bottom: -1px;
        left: 0;
        height: 2px;
        background: #409eff;
        content: '';
      }
    }
  }

  .review-detail-section {
    margin-bottom: 28px;

    h4 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0 0 18px;
      color: #414850;
      font-size: 14px;
      font-weight: 500;

      &::before {
        width: 3px;
        height: 13px;
        background: #409eff;
        content: '';
      }
    }
  }

  .review-detail-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px 27px;
    margin: 0;

    > div {
      display: grid;
      grid-template-columns: 92px minmax(0, 1fr);
      gap: 8px;
      min-width: 0;
      font-size: 13px;
      line-height: 21px;
    }

    .is-wide { grid-column: 1 / -1; }
    dt { color: #969da6; }
    dd { margin: 0; color: #5c646d; overflow-wrap: anywhere; }
  }

  .review-detail-timeline {
    min-height: 120px;
  }

  .review-change-table {
    margin-top: 16px;
    font-size: 12px;

    th { background: #f8fafc; }
    td:last-child { color: #409eff; }
  }

  .review-detail-empty {
    padding: 30px 0;
    text-align: center;
    color: #909399;
  }

  .review-detail-event {
    position: relative;
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-left: 5px;
    padding: 0 0 27px 24px;
    border-left: 1px solid #e3eaf3;
    font-size: 13px;

    &::before {
      position: absolute;
      top: 5px;
      left: -5px;
      width: 9px;
      height: 9px;
      border: 2px solid #fff;
      border-radius: 50%;
      background: #b2c5db;
      content: '';
    }

    &:first-child::before { background: #409eff; }
    &:last-child { border-color: transparent; }
    strong { color: #505963; font-weight: 500; }
    time { flex: none; color: #a0a6af; font-size: 12px; }
  }

  .review-detail-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    min-height: 75px;
    padding: 16px 28px;
    border-top: 1px solid #e7edf5;
    box-shadow: 0 -3px 10px #e6ebf433;
  }

  .review-footer-meta {
    margin-right: auto;
    color: #909399;
    font-size: 12px;
  }

  .el-button + .el-button {
    margin-left: 0;
  }
}

.review-modal-object {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 22px;
  color: #4f5762;

  strong { font-weight: 500; }
  span { color: #959da7; font-size: 12px; }
}

.review-period-options {
  display: flex;
  width: 100%;

  .el-radio-button { flex: 1; }
  .el-radio-button__inner { width: 100%; padding: 11px 5px; }
}

.review-period-preview {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  padding: 12px 14px;
  background: #f7faff;
  color: #8692a2;
  font-size: 12px;

  strong { color: #409eff; font-size: 13px; font-weight: 500; }
}

.review-modal-note {
  margin-top: 18px;
  padding: 11px 13px;
  border-radius: 3px;
  background: #ecf5ff;
  color: #6796c5;
  font-size: 12px;
  line-height: 1.9;

  &--warning {
    background: #fdf6ec;
    color: #b99058;
  }
}

.audit-dialog,
.adjust-dialog {
  max-width: calc(100vw - 28px);
}

@media (max-width: 640px) {
  .detail-drawer {
    .el-drawer__header { padding: 18px; }
    .review-detail-body { padding: 22px 18px; }
    .review-detail-grid { grid-template-columns: 1fr; }
    .review-detail-footer { padding: 15px 18px; }
    .review-footer-meta { display: none; }
  }
}

.log-drawer {
  max-width: 100vw;

  .el-drawer__body {
    padding: 0 20px 20px;
  }
}
</style>
